let initialState = {
  settingConfig: {
    channel_list: ["twitter", "instagram"],
    channel_setting: {
      channel_content_type: {
        mention: true,
        hashtag: false,
      },
      hashtag_list: [],
      mention_list: [],
      keywords: {
        and_type: true,
        and_keywords: [],
        or_keywords: [],
        not_keywords: [],
      },
      media_type: {
        image: true,
        video: true,
        text: false,
      },
      followers_count_greater_than: 0,
      followers_count_less_than: 0,
    },
    channels: [
      {
        channel_name: "twitter",
        is_selected: true,
        channel_setting: {
          channel_content_type: {
            mention: true,
            hashtag: false,
          },
          hashtag_list: [],
          mention_list: [],
          keywords: {
            and_type: true,
            and_keywords: [],
            or_keywords: [],
            not_keywords: [],
          },
          media_type: {
            image: true,
            video: true,
            text: false,
          },
          followers_count_greater_than: 0,
          followers_count_less_than: 0,
        },
      },
      {
        channel_name: "instagram",
        is_selected: true,
        channel_setting: {
          channel_content_type: {
            mention: true,
            hashtag: false,
            story_promotion: true,
          },
          hashtag_list: [],
          mention_list: [],
          story_mention_list: [],
          keywords: {
            and_type: true,
            and_keywords: [],
            or_keywords: [],
            not_keywords: [],
          },
          media_type: {
            image: true,
            video: true,
            text: false,
          },
          followers_count_greathertan: null,
          followers_count_lessthan: null,
        },
      },
    ],
    sentiment: {
      positive: true,
      neutral: true,
      negative: false,
    },
    social_wall_setting: {
      is_selected: true,
      post_presence_time: 5,
      post_presence_unit: "S",
      screen_presence_time: 1,
      screen_presence_unit: "M",
      repeat_post: {
        based_on_engagement: false,
        based_on_earliest_first: true,
      },
    },
    leaderboard_setting: {
      is_selected: true,
      screen_presence_time: 1,
      screen_presence_unit: "M",
    },
    analytics_setting: {
      is_selected: true,
      screen_presence_time: 1,
      screen_presence_unit: "M",
    },
    styling: {
      primary_color: "#42B549",
      background_color: "#000000",
      foreground_color: "#000000",
      screen_text: "USE #LOCOBUZZ_EVE TO SHOWCASE YOURSELF ON THE BIG SCREEN.",
      screen_sub_text: "Welcome to the biggest event of the year!",
    },
    brand_logo: "",
    screen_type: 0,
    ai_content: false,
    ai_moderation_obj: null,
    ai_moderation_offset: 0,
  },
  settingConfigIsSaving: { value: false, screen_type: null },
  lessThanFlag: false,
  launchedScreen: {
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  },
};

const SocialWallScreenSettings = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_SOCIAL_WALL_SCREEN_SETTINGS":
      return {
        ...initialState,
      };
    case "SETTING_CONFIG_IS_SAVING":
      return {
        ...state,
        settingConfigIsSaving: action?.payload,
      };
    case "SETTING_AI_MODERATION_NOTIFICATION":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          ai_moderation_obj: action?.aiModerationObj,
        },
      };
    case "SETTING_AI_MODERATION_NOTIFICATION_OFFSET":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          ai_moderation_offset: action?.aiModerationNotificationOffset,
        },
      };
    case "UPDATE_CHANNELS_SETTING_FOR_ALL_CHANNEL":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          channel_setting: action?.payload,
        },
      };
    case "UPDATE_CHANNELS_LIST":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          channels: action?.payload,
        },
      };
    case "SET_CHANNEL_LIST":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          channel_list: action?.payload,
        },
      };
    case "SET_SENTIMENT_VALUE":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          sentiment: action?.payload,
        },
      };
    case "SET_AI_CONTENT_VALUE":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          ai_content: action?.payload,
        },
      };
    case "SET_SCREEN_TYPE_VALUE":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          screen_type: action?.payload,
        },
      };
    case "UPDATE_SOCIAL_WALL_SETTING":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          social_wall_setting: action?.payload,
        },
      };
    case "UPDATE_LEADER_BOARD_SETTING":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          leaderboard_setting: action?.payload,
        },
      };
    case "UPDATE_ANALYTICS_SETTING":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          analytics_setting: action?.payload,
        },
      };
    case "UPDATE_STYLE_SETTING":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          styling: action?.payload,
        },
      };
    case "UPDATE_LAUNCH_SCREEN":
      return {
        ...state,
        launchedScreen: action?.payload,
      };
    case "LESS_THAN_FLAG":
      return {
        ...state,
        lessThanFlag: action?.payload,
      };
    // case "SET_AND_KEYWORD_TYPE_VALUE":
    //   return {
    //     ...state,
    //     settingConfig: {
    //       ...state?.settingConfig,
    //       [action?.channel?.type]: action?.channel?.value,
    //     },
    //   };
    case "UPDATE_BRAND_LOGO_SETTING":
      return {
        ...state,
        settingConfig: {
          ...state?.settingConfig,
          brand_logo: action?.payload,
        },
      };
    default:
      return state;
  }
};

export default SocialWallScreenSettings;
